var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { style: _vm.s.body }, [
        _c("div", { staticClass: "__row" }, [
          _c("div", { staticClass: "__row_t" }, [
            _vm._v(_vm._s(_vm.$t("tokenCard.heads.availableExAmount")))
          ]),
          _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
            _c("img", {
              staticClass: "__icon",
              attrs: { src: _vm.viteTokenInfo ? _vm.viteTokenInfo.icon : "" }
            }),
            _c("span", [_vm._v(_vm._s("dSLS"))]),
            _c("span", { staticClass: "__right blue" }, [
              _vm._v(_vm._s(_vm.exViteBalance))
            ])
          ])
        ]),
        _c("div", { staticClass: "__row" }, [
          _c("div", { staticClass: "__row_t" }, [
            _vm._v(_vm._s(_vm.$t("tradeVip.svipConfirm.openStakingAmount"))),
            _vm.isNoBalance
              ? _c("div", { staticClass: "__err" }, [
                  _vm._v(_vm._s(_vm.$t("tradeVip.vipConfirm.noBalance")))
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "__input_row __unuse_input" }, [
            _vm._v("1,000,000 dSLS")
          ])
        ]),
        _c(
          "div",
          { staticClass: "__row" },
          [
            _c("div", { staticClass: "__row_t" }, [
              _vm._v(_vm._s(_vm.$t("tradeVip.svipConfirm.address"))),
              !_vm.isAddress
                ? _c("div", { staticClass: "__err" }, [
                    _vm._v(_vm._s(_vm.$t("hint.addrFormat")))
                  ])
                : _vm._e()
            ]),
            _c(
              "vite-input",
              {
                staticClass: "block_input",
                attrs: {
                  placeholder: _vm.$t("tradeVip.svipConfirm.addressPlaceholder")
                },
                model: {
                  value: _vm.inputAddress,
                  callback: function($$v) {
                    _vm.inputAddress = $$v
                  },
                  expression: "inputAddress"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "__all_wrapper __pointer",
                    attrs: { slot: "after" },
                    on: { click: _vm.fillMyAddr },
                    slot: "after"
                  },
                  [
                    _c("span", { staticClass: "__all" }, [
                      _vm._v(_vm._s(_vm.$t("walletQuota.myAddr")))
                    ])
                  ]
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "__hint" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("tradeVip.svipConfirm.openHint")))])
        ])
      ]),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }